import { useQuery } from "@/api/swr/useQuery";
import { answeringAssessmentSchema } from "@/schema/console/checking-assessments/AnsweringAssessment";

type Config = Parameters<typeof useQuery<typeof answeringAssessmentSchema>>[2];

export function useGetReAssessment(id: string, config?: Config) {
  return useQuery(
    answeringAssessmentSchema,
    `/console/re_assessments/${id}`,
    config,
  );
}
